import React, { useMemo } from 'react'
import { Text } from '@chakra-ui/react'
import { useMessageProperties } from '../message-provider'
import { getClientFullName } from '~utils/helpers'
import { ChatMessageFieldsFragment } from '~graphql/generated/graphql'

export default function MessageName() {
    const { message } = useMessageProperties()

    const isInternal = message.hidden_for_client

    const nameToDisplay = useMemo(() => {
        if (message.client) return getClientMessageName(message)
        if (message.clinic_user) return getClientFullName(message.clinic_user)
        return 'Anonymous'
    }, [message])

    return (
        <Text fontWeight="medium" fontSize="xs" color="gray.700">
            {nameToDisplay}
            {isInternal && ' (Internal)'}
        </Text>
    )
}

function getClientMessageName(message: ChatMessageFieldsFragment): string {
    if (message.client_phone && message.client_phone.name) {
        return message.client_phone.name
    }

    return getClientFullName(message.client, true) ?? 'Anonymous'
}
